import React from "react";
import ChangePasswordModalComponent from "../../components/UserForm/changePasswordModal";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import * as userAuthActions from "../../redux/actions/userAuthAction";
import * as forgotPasswordActions from "../../redux/actions/forgotPasswordAction";
import { useSelector, useDispatch } from "react-redux";

const ConfirmationModalPopup = (props) => {
  const dispatch = useDispatch();
  const modalReducer = useSelector((state) => state.modalReducer);

  const modalAction = bindActionCreators(modalActions, dispatch);
  const userAuthAction = bindActionCreators(userAuthActions, dispatch);
  const forgotPasswordAction = bindActionCreators(forgotPasswordActions, dispatch);


  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const handleSubmit = (data) => {
    if (props.callApiText == "UserList")
      userAuthAction.changePassword(props.authUserId, data.password);
    else if (props.callApiText == "ResetPasswordModal")
      forgotPasswordAction.changePassword(props.authUserId, data.password);
    closeRemoveModal();
  }

  const resetVerifyOtpData = () => {
    forgotPasswordAction.resetVerifyOtpData();
  }


  return (
    <ChangePasswordModalComponent
      closeRemoveModal={closeRemoveModal}
      handleSubmit={handleSubmit}
      modalReducer={modalReducer}
      resetVerifyOtpData={resetVerifyOtpData}
      {...props}
    />
  );
};
export default ConfirmationModalPopup;
